var _circle, _path, _path2, _path3, _path4, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordReset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 160,
    viewBox: "0 0 480 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 197.732,
    cy: 86.2788,
    r: 54.6691,
    fill: "#EEEEF0",
    stroke: "#EEEEF0",
    strokeWidth: 11.034
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.563 71.4775V116.678C201.563 122.05 205.915 126.401 211.287 126.401H279.347C284.719 126.401 289.071 122.05 289.071 116.678V71.4775",
    fill: "#B7B8C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.563 71.4775V116.678C201.563 122.05 205.915 126.401 211.287 126.401H279.347C284.719 126.401 289.071 122.05 289.071 116.678V71.4775",
    stroke: "#B7B8C2",
    strokeWidth: 6.5175,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.872 63.4116L239.875 40.5371C241.484 39.4556 243.379 38.8779 245.318 38.8779C247.256 38.8779 249.151 39.4556 250.76 40.5371L284.764 63.4116C290.491 67.2671 290.491 75.6926 284.764 79.5479L256.206 98.7616C249.623 103.191 241.017 103.191 234.435 98.7616L205.876 79.5479C200.144 75.6926 200.144 67.2621 205.872 63.4116Z",
    fill: "#FDFDFD",
    stroke: "#B7B8C2",
    strokeWidth: 6.5175,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228.872 65.8193H261.767M232.491 78.8681H258.284",
    stroke: "#006546",
    strokeWidth: 6.1015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.372,
    cy: 105.284,
    r: 21.1172,
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordReset);
export default __webpack_public_path__ + "static/media/password-reset.7b704cf8f9a9b1f0cb87c02f943cc2bd.svg";
export { ForwardRef as ReactComponent };